import { useEffect, useState } from "react";

export function isPwaStandalone() {
  if (typeof window === "undefined") return false;
  return window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true;
}

export function usePwaStandalone() {
  const [standalone, setStandalone] = useState(() => isPwaStandalone());

  useEffect(() => {
    const media = window.matchMedia?.("(display-mode: standalone)");
    const update = () => setStandalone(isPwaStandalone());
    update();
    media?.addEventListener?.("change", update);
    window.addEventListener("appinstalled", update);
    return () => {
      media?.removeEventListener?.("change", update);
      window.removeEventListener("appinstalled", update);
    };
  }, []);

  return standalone;
}
